import { useEffect } from 'react'

export default function useScrollToTop (Component) {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return Component
}